export default "__VITE_ASSET__$aQzc_wa__"